(function () {
  function initBmSkinSays() {
    const root = document.getElementById("bm-skin-says");
    if (!root) return;

    const cards = root.querySelectorAll(".bmss-card");

    cards.forEach((card) => {
      const imgEl = card.querySelector(".bmss-img");
      const dotsEl = card.querySelector(".bmss-dots");
      const prevBtn = card.querySelector(".bmss-nav--left");
      const nextBtn = card.querySelector(".bmss-nav--right");

      if (!imgEl) return;

      const raw = (card.dataset.images || "").trim();
      const images = raw
        .split("|")
        .map((s) => s.trim())
        .filter(Boolean);

      if (!images.length) return;

      let index = 0;

      function renderDots() {
        if (!dotsEl) return;
        dotsEl.innerHTML = images
          .map((_, i) => `<span class="bmss-dot ${i === index ? "is-active" : ""}"></span>`)
          .join("");
      }

      function setImage(i) {
        index = (i + images.length) % images.length;
        imgEl.src = images[index];
        renderDots();
      }

      // init
      setImage(0);

      prevBtn && prevBtn.addEventListener("click", (e) => {
        e.preventDefault();
        setImage(index - 1);
      });

      nextBtn && nextBtn.addEventListener("click", (e) => {
        e.preventDefault();
        setImage(index + 1);
      });
    });
  }

  document.addEventListener("DOMContentLoaded", initBmSkinSays);
  document.addEventListener("shopify:section:load", initBmSkinSays);
})();
